import { pipe } from "ramda";
import { ajax } from "common/mostAjax";

const AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL;

const getLibrariesUrl = () =>
  `${AUTH_BASE_URL}/roles/ROLE_PUBLIC_LIBRARY/organizations`;

const getOrganizationByAliasUrl = (alias) =>
  `${AUTH_BASE_URL}/organizations/alias/${alias}`;

export const fetchLibraries = pipe(getLibrariesUrl, ajax);

export const fetchOrganizationByAlias = pipe(getOrganizationByAliasUrl, ajax);
